import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../forum/app';
import FormModal from '../../common/components/FormModal';
import Button from '../../common/components/Button';
import LogInButtons from './LogInButtons';
import extractText from '../../common/utils/extractText';
import ItemList from '../../common/utils/ItemList';
import Stream from '../../common/utils/Stream';
import ForgotPasswordModal from './ForgotPasswordModal';
export default class LogInModal extends FormModal {
  constructor() {
    super(...arguments);
    /**
     * The value of the identification input.
     */
    _defineProperty(this, "identification", void 0);
    /**
     * The value of the password input.
     */
    _defineProperty(this, "password", void 0);
    /**
     * The value of the remember me input.
     */
    _defineProperty(this, "remember", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.identification = Stream(this.attrs.identification || '');
    this.password = Stream(this.attrs.password || '');
    this.remember = Stream(!!this.attrs.remember);
  }
  className() {
    return 'LogInModal Modal--small';
  }
  title() {
    return app.translator.trans('core.forum.log_in.title');
  }
  content() {
    return [m("div", {
      className: "Modal-body"
    }, this.body()), m("div", {
      className: "Modal-footer"
    }, this.footer())];
  }
  body() {
    return [m(LogInButtons, null), m("div", {
      className: "Form Form--centered"
    }, this.fields().toArray())];
  }
  fields() {
    const items = new ItemList();
    const identificationLabel = extractText(app.translator.trans('core.forum.log_in.username_or_email_placeholder'));
    const passwordLabel = extractText(app.translator.trans('core.forum.log_in.password_placeholder'));
    items.add('identification', m("div", {
      className: "Form-group"
    }, m("input", {
      className: "FormControl",
      name: "identification",
      type: "text",
      placeholder: identificationLabel,
      "aria-label": identificationLabel,
      bidi: this.identification,
      disabled: this.loading
    })), 30);
    items.add('password', m("div", {
      className: "Form-group"
    }, m("input", {
      className: "FormControl",
      name: "password",
      type: "password",
      autocomplete: "current-password",
      placeholder: passwordLabel,
      "aria-label": passwordLabel,
      bidi: this.password,
      disabled: this.loading
    })), 20);
    items.add('remember', m("div", {
      className: "Form-group"
    }, m("div", null, m("label", {
      className: "checkbox"
    }, m("input", {
      type: "checkbox",
      bidi: this.remember,
      disabled: this.loading
    }), app.translator.trans('core.forum.log_in.remember_me_label')))), 10);
    items.add('submit', m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('core.forum.log_in.submit_button'))), -10);
    return items;
  }
  footer() {
    return m('[', null, m("p", {
      className: "LogInModal-forgotPassword"
    }, m(Button, {
      className: "Button Button--text Button--link",
      onclick: this.forgotPassword.bind(this)
    }, app.translator.trans('core.forum.log_in.forgot_password_link'))), app.forum.attribute('allowSignUp') && m("p", {
      className: "LogInModal-signUp"
    }, app.translator.trans('core.forum.log_in.sign_up_text', {
      a: m(Button, {
        className: "Button Button--text Button--link",
        onclick: this.signUp.bind(this)
      })
    })));
  }

  /**
   * Open the forgot password modal, prefilling it with an email if the user has
   * entered one.
   */
  forgotPassword() {
    const email = this.identification();
    const attrs = email.includes('@') ? {
      email
    } : undefined;
    app.modal.show(ForgotPasswordModal, attrs);
  }

  /**
   * Open the sign up modal, prefilling it with an email/username/password if
   * the user has entered one.
   */
  signUp() {
    const identification = this.identification();
    const attrs = {
      [identification.includes('@') ? 'email' : 'username']: identification
    };
    app.modal.show(() => import(/* webpackChunkName: 'forum/components/SignUpModal', webpackMode: 'lazy-once' */ './SignUpModal'), attrs);
  }
  onready() {
    this.$('[name=' + (this.identification() ? 'password' : 'identification') + ']').trigger('select');
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    app.session.login(this.loginParams(), {
      errorHandler: this.onerror.bind(this)
    }).then(() => window.location.reload(), this.loaded.bind(this));
  }
  loginParams() {
    const data = {
      identification: this.identification(),
      password: this.password(),
      remember: this.remember()
    };
    return data;
  }
  onerror(error) {
    if (error.status === 401 && error.alert) {
      error.alert.content = app.translator.trans('core.forum.log_in.invalid_login_message');
      this.password('');
    }
    super.onerror(error);
  }
}
flarum.reg.add('core', 'forum/components/LogInModal', LogInModal);flarum.reg.addChunkModule('559', '9509', 'core', 'forum/components/SignUpModal');